module.exports = __webpack_public_path__ + "static/media/sensor-smoke.fe917806.svg";